import i18n from '../i18n'

/**
 * Restituisce il titolo dell'articolo nella lingua corrente dell'app.
 * Se il titolo nella lingua corrente non è presente, fa fallback sulle altre.
 * @param {Object} articolo - Oggetto articolo con titolo_it, titolo_fr, titolo_en
 * @param {string} [fallback=''] - Valore di fallback se nessun titolo è presente
 * @returns {string}
 */
export function getTitoloByLang (articolo, lang, fallback = '') {
  if (!articolo) return fallback
  const chains = {
    it: ['it', 'fr', 'en'],
    fr: ['fr', 'it', 'en'],
    en: ['en', 'it', 'fr']
  }
  const chain = chains[lang] || chains.it
  for (const l of chain) {
    const val = articolo[`titolo_${l}`]
    if (val && typeof val === 'string' && val.trim()) return val.trim()
  }
  if (articolo.titolo && typeof articolo.titolo === 'string' && articolo.titolo.trim()) return articolo.titolo.trim()
  return fallback
}

export function getTitoloI18n (articolo, fallback = '') {
  if (!articolo) return fallback
  const lang = (i18n.language || 'it').slice(0, 2)
  const chains = {
    it: ['it', 'fr', 'en'],
    fr: ['fr', 'it', 'en'],
    en: ['en', 'it', 'fr']
  }
  const chain = chains[lang] || chains.it
  for (const l of chain) {
    const val = articolo[`titolo_${l}`]
    if (val && typeof val === 'string' && val.trim()) return val.trim()
  }
  if (articolo.titolo && typeof articolo.titolo === 'string' && articolo.titolo.trim()) return articolo.titolo.trim()
  return fallback
}
